import { Button, Text } from "@chakra-ui/react";
import { t } from "i18next";

export interface PreviewReleaseButtonProps {
  goToCTAUrl: () => void;
  size?: "sm" | "md" | "lg";
}

export function PreviewReleaseButton({
  goToCTAUrl,
  size = "sm",
}: PreviewReleaseButtonProps) {
  return (
    <Button
      variant="tertiary"
      alignSelf="flex-start"
      size={size}
      onClick={() => goToCTAUrl()}
      borderColor="transparent.white.40"
    >
      <Text fontSize="12px" lineHeight="11px" fontWeight="500" color="dune.100">
        {t("components.releases.actions.preview")}
      </Text>
    </Button>
  );
}
